<template>
<div fluid class="p-0 m-0">
    <!-- "The holy" Table-->
    <b-card body-class="m-0 p-0" >
      <!-- Table header card -->
      <div slot="header">
        <b-row >
          <!-- title -->
          <b-col class="m-auto"> <strong>ALL Registations</strong> </b-col>
          <!-- search bar -->
          <b-col class="m-auto" sm="7" >
            <b-form-group horizontal class="mb-0" >
              <b-input-group >
                <b-input-group-prepend>
                  <b-form-select id="year-select" @change="getPilgrimsByYear" :options="years" v-model="year" varient="info" />
                </b-input-group-prepend>
                <b-form-input v-model="filter" placeholder="Type to Search" />
                <b-input-group-append>
                  <b-btn :disabled="!filter" @click="filter = ''">Clear</b-btn>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
          </b-col>
          <!-- show how many pages -->
          <b-col class="m-auto">
            <b-form-group horizontal prepend="Show"  class="m-auto">
              <b-input-group prepend="Show">
                <b-form-select :options="pageOptions" v-model="perPage" />
              </b-input-group>
            </b-form-group>
          </b-col>
        </b-row>
      </div>
      <!-- Table body -->
      <b-table 
        class="mb-0 table-outline"
        show-empty hover small
        stacked="sm"
        responsive="sm"
        :items="tableItems" 
        :fields="tableFields"
        :current-page="currentPage"
        :per-page="perPage"
        :filter="filter"
        @filtered="onFiltered"
        head-variant="dark"
        :busy.sync="isBusy" 
      >
      <!-- selectable select-mode='single'
        selectedVariant="info"
        @row-selected="rowSelected" -->

        <!-- busy state -->
        <div slot="table-busy" class="text-center text-danger my-2">
          <b-spinner class="align-middle" />
          <strong> Loading...</strong>
        </div>
        <!--options  -->
        <div slot="options" slot-scope="row" class="">
          <b-button size="" variant="info" class="p-1 mb-1"
            @click="printClicked(row.item, row.index, $event.target)"
            >View
          </b-button>
          <!-- &nbsp -->
          <b-button size="" class="p-1 ml-1 mb-1" 
            @click="editClicked(row.item, row.index, $event.target)"
            >Edit
          </b-button>
          <!-- &nbsp -->
          <b-button size="" class="p-1 ml-1 mb-1" v-bind:class="{
              'bg-warning': row.item.registration.status == 'Incomplete', 
              'bg-success': row.item.registration.status == 'Complete' 
            }"
            @click="installmentClicked(row.item, row.index, $event.target)"
            >installment
          </b-button>
          <b-button size="" class="p-1 ml-1 mb-1" variant="danger" 
            @click="deleteClicked(row.item, row.index, $event.target)"
            >Delete
          </b-button>
        </div>
        <!--image  -->
        <div slot="image" class="" slot-scope="item" >
          <b-img  :src="item.item.image+'?'+Date()" v-bind="imageProp" rounded ></b-img>
          <!-- {{item.item.image}}              -->
        </div>
        <!-- Information -->
        <div slot="pilgrimInfo" class="text-left" slot-scope="item">
          <div >
            <i class="fa fa-user fa-md "></i>
              <strong> {{ item.item.name }}</strong> 
          </div>
          <div>  
            <i class="fa fa-pencil fa-md  "></i>
            <!-- {{item.item.registration.date}} -->
            {{  (new Date(item.item.registration.date)).getDate() 
            + '-' + 
            monthNames[ ((new Date(item.item.registration.date)).getMonth()) ] 
            + '-' + 
            (new Date(item.item.registration.date)).getFullYear()  }}
          </div>
          <div>  
            <!-- <i class="fa fa-money "></i> -->
            <strong> {{item.item.gender}} </strong>
          </div>
        </div> 
        <!-- IDs -->
        <div slot="IDs" slot-scope="item" >
          <div><strong>
              {{item.item.HLID}}
              </strong> 
          </div>
          <div><strong> Trk.ID:</strong>
              {{item.item.trackingID}} 
          </div>
          <div><strong>NID:</strong>
              {{item.item.nid}} 
          </div>
        </div>
        <!-- passport -->
        <div slot="passport" slot-scope="item" >
          <div>
            <i class="fa fa-drivers-license fa-md  "></i>
              {{item.item.passportNo}} 
          </div>
          <div>
            <i class="fa fa-calendar-times-o fa-md "></i>
            {{item.item.passportIssue}}
          </div>
        </div>
        <!-- contact -->
        <div slot="contact" slot-scope="item" >
          <div v-if="item.item.phone != null && item.item.phone.search(',') > -1">
            <div>
              <i class="fa fa-phone fa-md "></i>
              {{item.item.phone.split(',')[0]}}
            </div>
            <div>
              <i class="fa fa-phone fa-md "></i>
              {{item.item.phone.split(',')[1]}}
            </div>
          </div>
          <div v-else>
            <i class="fa fa-phone fa-md "></i>
              {{ item.item.phone }}
          </div>
        </div>
        <!-- registration status -->
        <div slot="registration" slot-scope="item">
          <div>
            <h4>
              <b-badge v-bind:class="{ 
                'bg-success': item.item.registration.status == 'Complete',  
                'bg-warning': item.item.registration.status == 'Incomplete' 
                }">
                {{item.item.registration.status}}
              </b-badge>
            </h4>
          </div>
        </div>
        <!-- payments -->
        <div slot="payments" slot-scope="item">
          <div>
          <strong>{{formatToBDT(item.item.payment.paid)}}</strong>
          </div>
          <div>
          <strong>Payment #{{ item.item.payment.count }}</strong>
          </div>
        </div>
        <!-- address -->
        <div slot="address" slot-scope="item">
          <div>
            {{ item.item.presentAddr.vhr }},
          </div>
          <div>
            {{ item.item.presentAddr.po }},
            {{ item.item.presentAddr.policeStation }},
          </div>
          <div>
            {{ item.item.presentAddr.district }},
            {{ item.item.presentAddr.pc}}
            <!-- <strong>Nikunja, Dhaka-1229</strong> -->
          </div>
        </div>
      </b-table>
      <!-- table pagination -->
      <b-row>
        <b-col md='0' class=" mx-auto">
          <b-pagination :total-rows="totalRows" :per-page="perPage" v-model="currentPage" class="my-0" />
        </b-col>
      </b-row>
      <!-- delete confirmation modal -->
      <b-modal ref="deleteModal" hide-footer title="Are you sure? this action cannot be undone!" >
        <!-- <pre>{{ modalInfo.content }}</pre> -->
        <b-row align-h="around">
          <b-img :src="modal.item.image" height="95" width="75"/>
          {{modal.item.name}}
          <b-button @click="deleteData(modal.item, modal.index)" variant="danger" >
            Delete
          </b-button>
          <b-button @click="cancelModal">
            Cancel
          </b-button>
        </b-row>
      </b-modal>
    </b-card>
  </div>
</template>

<script>
var monthNames = [
    "January", "February", "March",
    "April", "May", "June", "July",
    "August", "September", "October",
    "November", "December"
];

const invoiceData=[
  {HLID:"01-Jan-2019#1", amount:150000, paymentNO:4}
]

// import { Callout } from '@coreui/vue'
// import Details from './TableRowDetails'
import axios from 'axios'
import VueNotifications from 'vue-notifications'

export default {
  name: 'pilgrimTable',
  data () {
    return {
      monthNames: [
        "January", "February", "March",
        "April", "May", "June", "July",
        "August", "September", "October",
        "November", "December"
      ],
      years:[],
      phArr:"",
      showModal:false,
      year:null,
      tableItems: [],
      isBusy:true,
      currentPage: 1,
      perPage:5,
      totalRows: 0,
      pageOptions: [ 5,10,20 ],
      filter:null,
      imageProp: { width: 49, height: 63 },
      viewModal:{title:'',content:''},  
      addr:"",
      modal:{
        item:{},
        index:null
      },
      tableFields: {
        image: { label: 'Photo', class: 'imageProp'},
        pilgrimInfo: { label: "Pilgrim"},
        IDs:{ label: 'IDs' },
        passport:{label:"Passport"},
        contact: { label: 'Contact' },
        address: { label: 'Present Address' },
        registration:{label:"Registration", sortable:true},
        payments:{label:"Payments" },
        options:{ label:'Options' }
      }
    }
  },
  created(){
    this.prepareTable();
  },
  methods: {
    formatToBDT(val){
      return new Intl.NumberFormat('en-IN', { style: 'currency', currency: 'BDT' }).format(val);
    },
    formatPhone(val){
      if(val.search(',') > -1){
        this.phArr = val.split(',');
      }
    },
    editClicked(item, index, button){
      this.$router.push({
        name:'Registration', 
        params:{
          pilgrim:item,
          mode:"edit"
        }
      });
    },
    installmentClicked(item, index, button){
      if(item.registration.status== 'Complete' ){
        this.$router.push( {
          name:'Payments', 
          params:{ 
            pilgrim:item
          } 
        });
      }
      else{
        this.showWarnMsg({title:"Complete registration to process payments from "+ item.name});
      }
    },
    printClicked(item, index, button){ //view and print
      this.$router.push({
        name:'Registration', 
        params:{
          pilgrim:item,
          mode:"print"
        }
      });
    },
    deleteClicked(item, index, button){
      this.modal.item=item;
      this.modal.index=index;
      this.$refs.deleteModal.show();
    },
    cancelModal(){
      this.$refs.deleteModal.hide();
    },
    deleteData(item, index){
      this.$refs.deleteModal.hide();      
      // axios.get(`http://192.168.100.107:8080/pilgrimDB/removeData.php`,{
      axios.get(`pilgrimDB/removeData.php`,{
      params:{ HLID:item.HLID, image:item.image}, withCredentials: true
      })
      .then(response => {
        if(response.data == 1){
          this.showInfoMsg({title:item.name+"'s registration deleted"})
          this.tableItems.splice(index,1);
          // this.updated();
        }
      })
      .catch(error => {
        if( !error.response){
          this.showErrorMsg({title:"Network Error!"})
        }
        else{
          this.showErrorMsg({title:error.response})
        }
        console.log(error);
      });
    },
    getYearForFilter(){
      // return axios.get(`http://192.168.100.107:8080/pilgrimDB/pilgrimTable.php`,{
      return axios.get(`pilgrimDB/pilgrimTable.php`,{
      params:{ years:"yes" }, withCredentials: true
      })
      .then(response => {
        response.data.forEach( (elm, it, arr) => {
        this.years.push(elm['year']);
        });
      })
      .catch(error => {
        if(!error.response){
          this.showErrorMsg({title:"Network Error!!"})
        }
        else{
          this.showErrorMsg({title:error.response})
        }
        console.log(error);
      });
    },
    getPilgrimsByYear(year){
      // return axios.get( 'http://192.168.100.107:8080/pilgrimDB/pilgrimTable.php',{
      return axios.get( 'pilgrimDB/pilgrimTable.php',{
      params:{ filter:year}, withCredentials: true
      })
      .then(response => {
        this.tableItems = [];
        this.isBusy = true;
        response.data.forEach( (elm, it, arr) => {
          this.tableItems.push(JSON.parse(elm['information']));
        });
      })
      .catch(error => {
        if(!error.response){
          this.showErrorMsg({title:"Network Error!!"})
        }
        else{
          this.showErrorMsg({title:error.response})
        }
          console.log(error);
      })
      .then(()=>{
          this.totalRows = this.tableItems.length;
          this.isBusy = false;
      });
    },
    prepareTable(){
      this.getYearForFilter()
      .then(() =>{
        this.year = this.years[0];
        this.getPilgrimsByYear(this.year);
      })
    },
    rowSelected(row) {
        // this.selected = row;
        this.viewModal.title="All information";
        this.viewModal.content = JSON.stringify(row, null, 2);
        
        this.showModal=true;
    },
    rowColor(item, type){
      if(!item) return ;
      if(item.registration.status == 'Incomplete') return 'table-warning';
      if(item.registration.status == 'Complete') return 'table-success' ;   
    },
    onFiltered (filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
    info(item, index, button) {
      this.viewModal.title = `Row index: ${index}`
      this.viewModal.content = JSON.stringify(item, null, 2)
      this.$root.$emit('bv::show::modal', 'viewModal', button)
    },
    resetModal() {
      this.modalInfo.title = ''
      this.modalInfo.content = ''
    }
  },
  notifications: {
    showSuccessMsg: {
      type: VueNotifications.types.success,
      title: '',
      message: '',
      position: "topRight",
      timeout: 5000
    },
    showInfoMsg: {
      type: VueNotifications.types.info,
      title: '',
      message: '',
      position: "topRight",
      timeout: 5000

    },
    showWarnMsg: {
      type: VueNotifications.types.warn,
      title: '',
      message: '',
      position: "topRight",
      timeout: 10000

    },
    showErrorMsg: {
      type: VueNotifications.types.error,
      title: '',
      message: '',
      position: "topRight",
      timeout: 10000
    }
  }
}
</script>

<style>
  /* IE fix */
  *{
    font-size: 14px;
  }
 
  #card-chart-01, #card-chart-02 {
    width: 100% !important;
  }
</style>
